export enum StatusRemessa {
  CRIADO = "Criado",
  ENVIADO = "Enviado",
  RECEBIDO = "Recebido",
  RECUSADA = "Recusada",
  CANCELADO = "Cancelado",
  ERRO = "Erro",
}

export enum TypeRemessa {
  BOLETO = "Boleto",
  DEBITO_AUTOMATICO = "Débito Automático",
}
